import { render } from "./PortalBoardResources.vue?vue&type=template&id=d13b5708"
import script from "./PortalBoardResources.vue?vue&type=script&lang=js"
export * from "./PortalBoardResources.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__